const pad = (value: number): string => String(value).padStart(2, '0');

export const formatExportTimestamp = (date: Date = new Date()): string =>
  `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}_${pad(date.getHours())}${pad(date.getMinutes())}`;

export const buildExportFileName = (prefix: string, date: Date = new Date()): string =>
  `${prefix}_${formatExportTimestamp(date)}.csv`;
